import { useQuery } from '@tanstack/react-query';
import { DIAM_API_PATH, diamQueryKeys, getRoleById } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useRole(roleId: string | undefined) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: diamQueryKeys.role(roleId ?? ''),
    queryFn: async () => {
      if (!roleId) {
        throw new Error('A role id is required');
      }

      const idToken = await getIdToken();
      return getRoleById(apiUrl, idToken, roleId);
    },
    enabled: isSignedIn && Boolean(roleId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
